import React from 'react'

import ProjectCarouselButtons from '../ProjectCarouselButtons'

const AiChatBot = () => {
    return (
        <>
            <div className="Project--split--window">
                <div className="Project-Carousel-info-container">
                    <div id="carouselExampleIndicatorsAiChatBot" className="carousel slide Project-Carousel-container">

                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <video controls="controls" className="d-block w-100">
                                    <source src="../IMG/AiChatBot/AiChatBot.mp4" type="video/mp4" />
                                </video>
                            </div>
                        </div>

                        <ProjectCarouselButtons tag="AiChatBot" />

                    </div>

                    <div className="Project-info-container">
                        <div className="Project--info--Para-container">
                            <p className="Project--info--heading">AiChatBot</p>
                            <p className="Project--info--subheading">ML/AI Development</p>
                            <p className="Project--info--subheading">Neural Network</p>
                            <p className="Project--info--Para">The chatbot is a simple conversational agent designed to interact with users by understanding their input and providing appropriate responses. It's built using Python and leverages the power of Natural Language Processing (NLP) and a neural network for processing and generating responses.</p>
                            <p className="Project--info--Para">Conversational agent with NLTK for preprocessing, TensorFlow/Keras for neural network, JSON for intents, and confidence-based responses.</p>
                        </div>
                        {/* <div className="Project--info--links">
                            <a href="https://github.com/Chauhan-Aman/JAMSHACK23_UnityServe" target='__blank'>Github</a>
                        </div> */}
                        <div className="Project--info--tech">
                            <p>Python</p>
                            <p>NLTK</p>
                            <p>TensorFlow</p>
                            <p>Keras</p>
                            <p>Pickle</p>
                            <p>JSON</p>
                            <p>Sequential Model</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AiChatBot